import {
  AccountSimple,
  Crosstab,
  DeepProfileFull,
  MultiScore,
  MultiTimeview,
  Question,
  Scorecard,
  Segment,
} from "types";

import { Dashboard } from "types/dashboard";
import { ShareableArtifactTypes } from "consts";
import { User } from "types/users";
import { Usergroup } from "types/usergroups";
import { buildSharingPermissionTerms } from "utils";

const _permissionTypes = buildSharingPermissionTerms();
export type Permission = (typeof _permissionTypes)[number];
export type ArtifactModel =
  | Dashboard
  | Crosstab
  | Segment
  | MultiTimeview
  | MultiScore
  | DeepProfileFull
  | Scorecard
  | Question;

type ArtifactTypeKeys = keyof typeof ShareableArtifactTypes;
export type ArtifactType = (typeof ShareableArtifactTypes)[ArtifactTypeKeys];

export type Artifact = {
  artifactRefid: string | null; // uuid
  sharedToId: number | null;
  account_refid: number | null;
  permission: Permission;
};

type UserShareable = {
  user: User;
  artifact: Artifact;
};

type UsergroupShareable = {
  usergroup: Usergroup;
  artifact: Artifact;
};

export type Shareables = {
  users: UserShareable[];
  usergroups: UsergroupShareable[];
  account: Artifact;
  sharedAccounts: AccountSimple[];
  canWrite: boolean;
};

export type ShareableItem = {
  id: number;
  permission: Permission;
  label: string;
};

export type ShareablesFormValues = {
  account: ShareableItem;
  groups: ShareableItem[];
  users: ShareableItem[];
  sharedAccounts: AccountSimple[];
  notification: boolean;
};
